import { Globe, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage } from "@/context/LanguageContext";

export default function LanguageSwitcher({ compact = true }) {
  const { lang, setLang, languages } = useLanguage();
  const current = languages.find((l) => l.code === lang);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`inline-flex items-center gap-1.5 rounded-full border border-white/12 bg-white/[0.03] text-slate-300 hover:text-white hover:border-white/25 transition-colors ${compact ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm"}`}
          data-testid="language-switcher"
          aria-label="Change language"
        >
          <Globe className="h-3.5 w-3.5 text-[#4F8CFF]" />
          {compact ? current?.code.toUpperCase() : current?.native}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#0A1119] border-white/10 text-white min-w-[160px]">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between cursor-pointer focus:bg-white/5 focus:text-white"
            data-testid={`lang-option-${l.code}`}
          >
            <span>{l.native}</span>
            {lang === l.code && <Check className="h-3.5 w-3.5 text-[#4F8CFF]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
